import React from 'react';

interface PillOption {
  value: string;
  label: string;
}

interface PillSelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: PillOption[];
}

const PillSelector: React.FC<PillSelectorProps> = ({ value, onChange, options }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map(option => {
        const isSelected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`inline-flex min-h-[50px] min-w-[50px] shrink-0 items-center justify-center rounded-full border px-3 text-center transition-colors ${
              isSelected
                ? 'bg-gray-800 border-emerald-500 text-white'
                : 'bg-gray-700 border-gray-600 text-gray-400 hover:border-gray-500'
            }`}
          >
            <span className="whitespace-nowrap text-xs font-medium">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PillSelector;
